import { Component, OnInit, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ClientOrdersService } from 'src/app/services/apiclient/order/clientorders.service';
import { MediaObserver } from '@angular/flex-layout';
import { filterDateAnim } from 'src/app/models/consts/anims';
import { ToolsService } from 'src/app/services/tools/tools.service';
import { TranslateArrayService } from 'src/app/services/translateArray/translate';

@Component({
  selector: 'app-orders',
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.css'],
  animations: [
    filterDateAnim,
  ]
})

export class OrdersComponent implements OnInit {

  @Output() openSideDataEvent = new EventEmitter<any>();
  @Output() setSideDataEvent = new EventEmitter<any>();
  @Output() setSideTypeEvent = new EventEmitter<any>();

  @ViewChild('pageTitle') pageTitle: ElementRef |any;
  @ViewChild(MatPaginator) paginator: MatPaginator|any;
  @ViewChild(MatSort) sort: MatSort|any;

  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
 displayedColumns: string[] = ['order_level', 'date_creation', 'user_denomination', 'total', 'icon', 'print'];
  // Loaders
  loader: boolean = true;
  orderLoader: boolean = false;

  // Scroll
  titlePositionTop: number|any;

  filterDateAnimFlag: boolean = false;
  get getToggleFilterDate(): string { return this.filterDateAnimFlag ? "show" : "hide"; }

  constructor(
    private media: MediaObserver,
    private orderApi: ClientOrdersService,
    private tools: ToolsService,
    private TranslateArrayService: TranslateArrayService
  ) {
    this.onResp();
  }

  ngOnInit() {
    this.tools.setPageClient("orders");
    this.getOrders();
  }

  getOrders() {
    this.orderApi.getOrders().subscribe(orders => {
         setTimeout(() => {
        this.dataSource.data = orders;
        this.dataSource.paginator = this.paginator;
       
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.TranslateArrayService.get(this.dataSource.paginator);
        this.setDisplayedColumns();
        this.setTitlePosition();
      });
      this.loader = false;
    });
  }

  setTitlePosition() {
    this.titlePositionTop = this.pageTitle.nativeElement.getBoundingClientRect().top;
  }

  //userKey
  goPrint(userKey: string, orderId: number | string,) {
    window.open("http://pandor-201115.appspot.com/orders/dashboard/commande.html?user=" + userKey + "&id=" + orderId, "_blank");
  }

  openSideOrder(order: any) {
      this.tools.setSideData({ type: "order", data: order });
  }

  setOrderLoader($event: boolean) {
    if ($event) {
      this.filterDateAnimFlag = false;
    }
    this.orderLoader = $event;
  }

  setOrders($event: any) {
    this.dataSource.data = $event;
  }

  onResp() {
    this.media.asObservable().subscribe(media => {

      this.setDisplayedColumns();

      if (this.titlePositionTop) {
        this.titlePositionTop = this.pageTitle.nativeElement.getBoundingClientRect().top + 10;
      }
    });
  }

  setDisplayedColumns() {
  
    this.displayedColumns = this.media.isActive("xs")
      ? ['order_level', 'date_creation', 'user_denomination', 'total', 'icon', 'print']
      : ['order_level', 'date_creation', 'user_denomination', 'total', 'icon', 'print'];
  }

}




